import { create } from "zustand";

export interface IRoadFeatureResponseMarkersActions {
    setOpen: (open: boolean) => void;
    toggleOpen: () => void;
}

export interface IRoadFeatureResponseMarkersState {
    actions: IRoadFeatureResponseMarkersActions;
    open: boolean;
}

const useRoadFeatureResponseMarkersStore = create<IRoadFeatureResponseMarkersState>( (set) => ({
    open: false,
    actions: {
        setOpen: (open: boolean) => {
            set({open: open});
        },
        toggleOpen: () => {
            set((state) => ({open: !state.open}));
        }
    }
}));

export const useRoadFeatureResponseMarkersState = () => useRoadFeatureResponseMarkersStore((state) => state.open);
export const useRoadFeatureResponseMarkersActions = () => useRoadFeatureResponseMarkersStore((state) => state.actions);